import { ReactNode, Children } from 'react';

interface DividerContainerProps {
  wrapperCls?: string;
  dividerCls?: string;
  children: ReactNode;
}

/**
 * 以组合的形式，在列表中插入间隔
 */
export default function DividerContainer(props: DividerContainerProps): JSX.Element {
  const { children, dividerCls, wrapperCls } = props;

  const content = Children.toArray(children)
    .filter(Boolean)
    .flatMap((child, index) => {
      if (index === 0) {
        return [child];
      }
      return [dividerCls && <div className={dividerCls} key={`divider-${index}`} />, child];
    });

  if (wrapperCls) {
    return <div className={wrapperCls}>{content}</div>;
  } else {
    return <>{content}</>;
  }
}
